module.exports = __webpack_public_path__ + "img/banner-09.c96f61cf.jpg";